export const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID;
export const SVG_ASSERT_URL = `https://assets.kula.ai/images/static/core-web/svg`;
export const SUPPORT_HOME_URL = `https://support.kula.ai`;
export const SUPPORT_JOB_URL = `https://support.kula.ai/collections/4967476669-jobs`;
export const SUPPORT_JOB_BOARDS_URL = `https://support.kula.ai/collections/2019036941-job-boards`;
export const SUPPORT_WEBHOOKS_URL = `https://developers.kula.ai/docs/webhook-guides/setup`;
export const SUPPORT_PUBLIC_API_DOCUMENTATION_URL = `https://developers.kula.ai/docs/getting-started/overview`;

// Offices, departments and custom-field definitions are admin-managed config,
// so a page revisit inside this window reuses the cache instead of refetching.
export const FILTER_OPTIONS_STALE_SECONDS = 5 * 60;
export const FILTER_OPTIONS_STALE_MS = FILTER_OPTIONS_STALE_SECONDS * 1000;
